import { ReduxStore } from 'store/types';

function createIsLoading(state: ReduxStore): boolean {
  return state.user.create.config.isLoading;
}

export default createIsLoading;
